import { ListResponseModel, toQueryString } from ".";
import { RefundCase, RefundExportParams, RefundListParams, RefundSummary, RetryRefundResult } from "../model/refunds/refund";
import { apiSlice } from "../stores/base/api-slice";

// Utility admin only — the gateway's ViewRefundsPolicy / RetryRefundPolicy sit in front of
// every route here (Zepp.WebApp/Gateway/Gateway.API/ReverseProxy/Routes/59-refunds.routes.json).
const serviceBaseUrl = "/charge/refunds";

const refundEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getRefunds: builder.query<ListResponseModel<RefundCase[]>, RefundListParams>({
			providesTags: ["Refunds"],
			query: params => ({
				url: serviceBaseUrl + toQueryString(params),
				method: "GET",
			}),
		}),
		getRefundSummary: builder.query<RefundSummary, void>({
			providesTags: ["Refunds"],
			query: () => ({
				url: `${serviceBaseUrl}/summary`,
				method: "GET",
			}),
		}),
		getRefundDetails: builder.query<RefundCase, string>({
			providesTags: (_result, _error, transactionId) => [{ type: "Refund", id: transactionId }],
			query: transactionId => ({
				url: `${serviceBaseUrl}/${encodeURIComponent(transactionId)}`,
				method: "GET",
			}),
		}),
		retryRefund: builder.mutation<RetryRefundResult, string>({
			// A retry changes the case's status, the counts and the attempt history.
			invalidatesTags: (_result, _error, transactionId) => ["Refunds", { type: "Refund", id: transactionId }],
			query: transactionId => ({
				url: `${serviceBaseUrl}/${encodeURIComponent(transactionId)}/retry`,
				method: "POST",
			}),
		}),
		exportRefunds: builder.query<Blob, RefundExportParams>({
			query: params => ({
				url: `${serviceBaseUrl}/export` + toQueryString(params),
				method: "GET",
				responseHandler: async (response: Response) => response.blob(),
			}),
		}),
	}),
});

export const {
	useGetRefundsQuery,
	useGetRefundSummaryQuery,
	useGetRefundDetailsQuery,
	useRetryRefundMutation,
	useLazyExportRefundsQuery,
} = refundEndpoints;
